import { DictionaryItem } from '../public_api';
import { SourcesDictionaryItem } from './dictionaries/sourcesDictionaryItem';
import { LocationPoint, ObservationSummary } from './observationSummary';

export class SelectableObservationSummary {
  /**
   * Used to show whether this item was present in the last filtered search.
   */
  private selected = true;

  constructor(private summary: ObservationSummary) {}

  public get id(): string {
    return this.summary.id;
  }
  public get type(): DictionaryItem {
    return this.summary.type;
  }
  public get description(): string {
    return this.summary.description;
  }
  public get country(): DictionaryItem {
    return this.summary.country;
  }
  public get source(): SourcesDictionaryItem {
    return this.summary.source;
  }
  public get dateObserved(): moment.Moment {
    return this.summary.dateObserved;
  }
  public get location(): GeoJSON.Feature {
    return this.summary.location;
  }
  public get locationPoint(): LocationPoint {
    return this.summary.locationPoint;
  }

  public setSelected(selected: boolean): this {
    this.selected = selected;
    return this;
  }
  get isSelected(): boolean {
    return this.selected;
  }
}
